import {Scenario, StaticMethods, TestStatus, UploadInfo} from './GeneralModels';

export class PetOffer {
  public id: number;
  public name: string;
  public companyName: string;
  public services: string[];
  public overAllCoverage: string;
  public discountedAmount: string;
  public cost: string;
  public discountsList: string[];
  constructor({id, name, companyName, services, overAllCoverage, discountedAmount, cost, discountsList}) {
    this.id = id;
    this.name = name;
    this.companyName = companyName;
    this.services = services;
    this.overAllCoverage = StaticMethods.numberWithCommas(overAllCoverage);
    this.discountedAmount = discountedAmount ? StaticMethods.numberWithCommas(discountedAmount) : null;
    this.cost = StaticMethods.numberWithCommas(cost);
    this.discountsList = discountsList;
  }
}

export interface VisitSessionInfo {
  visitType: string;
  address: string;
  sessionStartTime: string;
  sessionEndTime: string;
  clinicName: string;
  expired: boolean;
}

export class PetRequest {
  public id: number;
  public birthYear: number;
  public petGender: string;
  public petName: string;
  public offerName: string;
  public UserFormsSubmission: boolean;
  public paid: boolean;
  public BirthCertificate: boolean;
  public visitSessionInfo: VisitSessionInfo;
  public status: boolean;
  public insuranceReleased: boolean;
  public vetReplyStatus = 'NO_REPLY';
  public currentStep: string;
  public viewArray: any;
  public testStatus: TestStatus[];

  constructor(data: any, scenario: Scenario) {
    this.id = data.id;
    this.petName = data.petName;
    this.birthYear = data.birthYear;
    this.petGender = data.petGender;
    this.testStatus = data.testStatus;
    this.offerName = data.offerName;
    this.BirthCertificate = data.BirthCertificate;
    this.UserFormsSubmission = data.UserFormsSubmission;
    this.visitSessionInfo = {
      address: data.visitSessionInfo.address,
      sessionStartTime: data.visitSessionInfo.sessionStartTime,
      sessionEndTime: data.visitSessionInfo.sessionEndTime,
      visitType: data.visitSessionInfo.visitType,
      clinicName: data.visitSessionInfo.clinicName,
      expired: data.visitSessionInfo.expired,
    };
    this.paid = data.paid;
    this.vetReplyStatus = data.vetReplyStatus;
    this.insuranceReleased = data.insuranceReleased;
    this.currentStep = StaticMethods.setStep(scenario, this.checkStepStatus, this);
    this.viewArray = {
      requestID: this.id,
      petGender: this.petGender,
      petName: this.petName,
      birthYear: this.birthYear,
      offer: this.offerName,
      FormsSubmission: this.UserFormsSubmission,
      paid_label: this.paid ? 'true_payment' : 'false_payment'
    };
    this.viewArray.vetReplyStatus = this.vetReplyStatus;
    if (this.vetReplyStatus !== 'REJECT') {
      this.viewArray.status = this.currentStep;
    }
  }

  private checkStepStatus = (step: string, object: PetRequest): boolean => {
    switch (step) {
      case PetScenario.formSubmitted:
        return object.UserFormsSubmission;
      case PetScenario.BirthCertificate:
        return object.BirthCertificate;
      case PetScenario.visitTypeSelected:
        return (!(!object.visitSessionInfo.visitType) && !object.visitSessionInfo.expired)
          || this.vetReplyStatus === 'ACCEPT';
      case PetScenario.paid:
        return object.paid;
      case PetScenario.visitSessionBooked:
        return (object.visitSessionInfo.sessionStartTime &&
          !(object.visitSessionInfo.expired && object.vetReplyStatus !== 'NO_REPLY')) || object.vetReplyStatus === 'ACCEPT';
      case PetScenario.waitingForVetReply:
        return !(!object.vetReplyStatus) && object.vetReplyStatus !== 'NO_REPLY';
      case PetScenario.testUploaded:
        return object.vetReplyStatus !== 'TEST' || (object.testStatus && !(!object.testStatus.length));
      case PetScenario.waitingForRelease:
        return object.insuranceReleased;
      case PetScenario.insuranceReleased:
        return !object.insuranceReleased;
    }
  }

  getFileInfo(): UploadInfo {
    if (!this.BirthCertificate) {
      return {
        englishName: 'PetBirthCertificate',
        persianName: 'تصویر شناسنامه حیوان خوانگی',
        id: this.id
      };
    } else {
      if (this.testStatus && this.testStatus.length) {
        return {
          englishName: this.testStatus[0].englishLabel,
          persianName: this.testStatus[0].persianLabel,
          id: this.id
        };
      }
    }
    return null;
  }
}


export class PetScenario {
  static readonly formSubmitted = 'formSubmitted';
  static readonly BirthCertificate = 'BirthCertificate';
  static readonly visitTypeSelected = 'VisitTypeSelected';
  static readonly waitingForVetReply = 'waitingForVetReply';
  static readonly visitSessionBooked = 'visitSessionPoked';
  static readonly rejected = 'rejected';
  static readonly testUploaded = 'testUploaded';
  static readonly paid = 'paid';
  static readonly waitingForRelease = 'waitingForRelease';
  static readonly insuranceReleased = 'insuranceReleased';
  static generalScenario = new Scenario([
    PetScenario.formSubmitted,
    PetScenario.BirthCertificate,
    PetScenario.visitTypeSelected,
    PetScenario.paid,
    PetScenario.visitSessionBooked,
    PetScenario.waitingForVetReply,
    PetScenario.testUploaded,
    PetScenario.waitingForRelease,
    PetScenario.insuranceReleased
  ]);
  static B2BScenario = new Scenario([
    PetScenario.formSubmitted,
    PetScenario.BirthCertificate,
    PetScenario.visitTypeSelected,
    PetScenario.paid,
    PetScenario.visitSessionBooked,
    PetScenario.waitingForVetReply,
    PetScenario.testUploaded,
    PetScenario.waitingForRelease,
    PetScenario.insuranceReleased
  ]);

  constructor() {
  }
}
